module.exports = __webpack_public_path__ + "32b4c2f25dd042eb439e40143920734b.svg";